import React from 'react';
import LoginComponent from '../../components/Auth/Login';
import Navbar from '../../components/Navbars/AppNavbar.js';
import FooterSmall from '../../components/Footers/FooterSmall.js';
import Footer from '../../components/Footers/Footer.js';
import Head from 'next/head';

export default function Auth({ children }) {
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link rel="canonical" href="https://musicart.io/auth/login" />
      </Head>

      <Navbar transparent />
      <main className="main auth_bg">
        <LoginComponent />
      </main>
      <Footer />
      <FooterSmall />
    </>
  );
}
